






























































































import 'vue-loading-overlay/dist/vue-loading.css'
import { Vue, Component } from 'vue-property-decorator'
import { videoAnalyzer, webmWhammyConvertor, gifConvertor } from '@/lib/video-convertor/index'
import { getReport, sendReport } from '@/lib/report'
import DialogPrompt from '@/views/common/DialogPrompt.vue'
import { Button } from 'mand-mobile'
import store from '@/store'
import { invalidTokenCheckAndHandler } from '../lib/invalidTokenCheckAndHandler'

interface IResolveResult {
  file?: File,
  isResolved?: boolean,
  resolveType?: 'whammy' | 'gif',
  resolvedFormat?: string,
  resolvedSize?: number,
  resolvedWidth?: number,
  resolvedHeight?: number,
  resolveTime?: number
  errorMsg?: string,
}
interface IUploadResult {
  code?: string,
  message?: string,
  uploadTime?: number,
  transactionId?: string,
  score?: number,
  errorMsg?: string,
  tryCount?: number,
  returnUrl?: string,
}
interface IDetectionResult {
  code: string,
  transactionId: string,
  message: string,
  data?: {
    score: number,
    tryCount: number,
    returnUrl: string,
  },
}

// tslint:disable-next-line
const Loading = require('vue-loading-overlay')

// common case: mp4, mov, webm, gif
const ACCEPT_SUFFIX = [
  'mp4', 'avi', 'flv', 'wmv', 'mov', 'rm', 'gif', 'webm', '3gp',
]
// byte
const MAX_SIZE = 1024 * 1024 * 1 // 1M
const MIN_DURATION = 2 // s
const MAX_DURATION = 12 // s
const FPS = 1
const WIDTH = 1280

@Component({
  components: {
    Loading,
    DialogPrompt,
    [Button.name]: Button,
  },
})
export default class Home extends Vue {
  preparing: boolean = false
  loading: boolean = false
  resolveType: string = ''
  bizToken: any = null
  isAllowUpload: boolean = true
  debugCount: number = 0
  // dialog
  lengthTooLongHint: boolean = false
  lengthTooShortHint: boolean = false
  formatNotSupportHint: boolean = false
  uploadFailedHint: boolean = false
  startUploadHint: boolean = false

  $refs!: {
    videoEl: HTMLVideoElement,
    inputVideoEl: HTMLInputElement,
  }
  get debugVideoEl() {
    return this.debugCount >= 5
  }
  startHandler() {
    this.$refs.inputVideoEl.click()
  }
  async inputVideoHandler() {
    const files = this.$refs.inputVideoEl.files
    const file = files ? files[0] : null

    if (!file) {
      return
    }

    // step 1 - prepare
    try {
      this.preparing = true
      await videoAnalyzer.prepare(file, this.videoAnalyzerConfirmHandler, this.$refs.videoEl)
    } catch (error) {
      console.error(error)
    } finally {
      this.preparing = false
    }

    // step2 - pre check
    const { fileSuffix, duration, size } = videoAnalyzer
    if (!ACCEPT_SUFFIX.includes(fileSuffix.toLowerCase())) {
      this.formatNotSupportHint = true
      console.warn('fileSuffix', fileSuffix)
      this.sendReportPreCheck(false, 'UNACCEPTED_SUFFIX')
      return
    }
    if (duration <= MIN_DURATION) {
      this.lengthTooShortHint = true
      console.warn('duration', duration)
      this.sendReportPreCheck(false, 'UNACCEPTED_DURATION')
      return
    }
    if (duration >= MAX_DURATION) {
      this.lengthTooLongHint = true
      console.warn('duration', duration)
      this.sendReportPreCheck(false, 'UNACCEPTED_DURATION')
      return
    }

    // step3 - resolve
    const resolveStartTime = new Date().getTime()
    const resolveResult = await this.resolveHandler(file)
    if (resolveResult.errorMsg) {
      this.sendReportResolve(false, resolveResult.errorMsg, resolveResult)
      return
    }
    // this.sendReportResolve(true, '', resolveResult)

    // step4 - upload
    if (!resolveResult.file) {
      return
    }
    const uploadStartTime = new Date().getTime()
    const uploadResult = await this.uploadHandler(resolveResult.file)
    // if is invalid token, direct to result page
    if (invalidTokenCheckAndHandler(uploadResult.code as string)) {
      return
    }
    if (uploadResult.errorMsg) {
      this.sendReportUpload(false, uploadResult.errorMsg, resolveResult, uploadResult)
      return
    }

    if (uploadResult.code === 'SUCCESS') {
      this.sendReportUpload(true, uploadResult.message || '', resolveResult, uploadResult)
      this.$router.push({
        name: 'result',
        query: {
          result: uploadResult.code,
          message: uploadResult.message,
          score: `${uploadResult.score}`,
          returnUrl: uploadResult.returnUrl,
        },
      })
    } else {
      this.sendReportUpload(false, uploadResult.message || '', resolveResult, uploadResult)
      this.$router.push({
        name: 'result',
        query: {
          biz_token: this.bizToken,
          result: uploadResult.code,
          message: uploadResult.message,
          returnUrl: uploadResult.returnUrl,
        },
      })
    }
  }
  async resolveHandler(file: File): Promise<IResolveResult> {
    const { size } = videoAnalyzer
    this.loading = true

    try {
      if (size <= MAX_SIZE) {
        return {
          file,
          isResolved: false,
        }
      }

      // logout file size with kb unit
      // console.log('orig size', `${file.size / 1024}k`)
      if (webmWhammyConvertor.isCompatible) {
        const whammyResolveStartTime = new Date().getTime()
        const convertedFile = await webmWhammyConvertor.start({ fps: FPS, width: WIDTH, onProcess: this.convertorProcessHandler } )
        // console.log('whammy size', `${convertedFile.size / 1024}k`)
        return {
          file: convertedFile,
          isResolved: true,
          resolveType: 'whammy',
          resolvedFormat: 'webm',
          resolvedSize: convertedFile.size,
          resolvedWidth: webmWhammyConvertor.resultWidth,
          resolvedHeight: webmWhammyConvertor.resultHeight,
          resolveTime: new Date().getTime() - whammyResolveStartTime,
        }
      }

      if (gifConvertor.isCompatible) {
        const gifResolveStartTime = new Date().getTime()
        const convertedFile = await gifConvertor.start({ fps: FPS, width: WIDTH, onProcess: this.convertorProcessHandler })
        // console.log('gif size', `${convertedFile.size / 1024}k`)
        return {
          file: convertedFile,
          isResolved: true,
          resolveType: 'gif',
          resolvedFormat: 'gif',
          resolvedSize: convertedFile.size,
          resolvedWidth: gifConvertor.resultWidth,
          resolvedHeight: gifConvertor.resultHeight,
          resolveTime: new Date().getTime() - gifResolveStartTime,
        }
      }

      throw new Error('NO COMPATIBLE CONVERTOR')
    } catch (error) {
      this.uploadFailedHint = true

      console.error(error)
      return { errorMsg: error.message }
    } finally {
      this.loading = false
    }
  }
  async uploadHandler(file: File): Promise<IUploadResult> {
    this.loading = true
    try {
      // console.log('uploadHandler', file.type, `${file.size / 1024}k`)
      const body = new FormData();
      body.append('video', file)
      body.append('token', this.bizToken)
      const uploadStartTime = new Date().getTime()
      const { data } = await this.$http.post<IDetectionResult>(
        '/liveness/h5/v1/detection',
        body,
        { headers: {'Content-Type': 'multipart/form-data' }},
      )
      return {
        code: data.code,
        message: data.message,
        transactionId: data.transactionId,
        score: data.data ? data.data.score : 0,
        uploadTime: new Date().getTime() - uploadStartTime,
        tryCount: data.data ? data.data.tryCount : 0,
        returnUrl: data.data ? data.data.returnUrl : '',
      }
    } catch (error) {
      console.error(error)
      return { errorMsg: error.message }
    } finally {
      this.loading = false
    }
  }
  videoAnalyzerConfirmHandler() {
    this.startUploadHint = true
    this.preparing = false
  }
  convertorProcessHandler(val: string) {
    console.log(`convertor processing ${val}`)
  }
  sendReportPreCheck(result: boolean, message: string) {
    const report = getReport()
    const reportDetail = report.info.detail
    reportDetail.state = 'PRE_CHECK'
    reportDetail.result = result
    reportDetail.message = message
    reportDetail.videoFileFullName = videoAnalyzer.fileFullName
    reportDetail.videoDuration = videoAnalyzer.duration
    reportDetail.videoOrigFormat = videoAnalyzer.fileSuffix
    sendReport(report)
  }
  getReportResolve(result: boolean, message: string, resolveResult: IResolveResult) {
    const report = getReport()
    const reportDetail = report.info.detail
    reportDetail.state = 'RESOLVE'
    reportDetail.result = result
    reportDetail.message = message

    reportDetail.videoFileFullName = videoAnalyzer.fileFullName
    reportDetail.videoDuration = videoAnalyzer.duration

    reportDetail.videoOrigFormat = videoAnalyzer.fileSuffix
    reportDetail.videoOrigSize = videoAnalyzer.size
    reportDetail.videoOrigWidth = videoAnalyzer.width
    reportDetail.videoOrigHeight = videoAnalyzer.height

    reportDetail.isResolved = resolveResult.isResolved
    reportDetail.resolveType = resolveResult.resolveType
    reportDetail.resolveTime = resolveResult.resolveTime
    reportDetail.videoResolvedFormat = resolveResult.resolvedFormat
    reportDetail.videoResolvedSize = resolveResult.resolvedSize
    reportDetail.videoResolvedWidth = resolveResult.resolvedWidth
    reportDetail.videoResolvedHeight = resolveResult.resolvedHeight

    return report
  }
  sendReportResolve(result: boolean, message: string, resolveResult: IResolveResult) {
    sendReport(this.getReportResolve(result, message, resolveResult))
  }
  sendReportUpload(result: boolean, message: string, resolveResult: IResolveResult, uploadResult: IUploadResult) {
    const report = this.getReportResolve(result, message, resolveResult)
    const reportDetail = report.info.detail
    reportDetail.state = 'UPLOAD'
    reportDetail.uploadTime = uploadResult.uploadTime
    reportDetail.transactionId = uploadResult.transactionId
    reportDetail.score = uploadResult.score
    reportDetail.tryCount = uploadResult.tryCount,
    reportDetail.returnUrl = uploadResult.returnUrl,
    sendReport(report)
  }
  uploadDialogHandler() {
    const videoEl = videoAnalyzer.video as HTMLVideoElement
    videoEl.load()
  }
  hideDialogHandler() {
    this.lengthTooLongHint = false
    this.lengthTooShortHint = false
    this.formatNotSupportHint = false
    this.uploadFailedHint = false
    this.startUploadHint = false
  }
  debugHandler() {
    this.debugCount++
  }
  mounted() {
    this.bizToken = this.$route.query.biz_token
    store.bizToken = this.$route.query.biz_token as string
    if (!this.bizToken) {
      this.isAllowUpload = false
      return
    }
  }
}
